<app-header></app-header>
<ion-content
  id="ion-content-load-screen"
  [class.loaded]="(spinnerSubject | async) === false"
>
  <!-- DESKTOP -->
  <div
    id="desktop"
    *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
  >
    <!-- Spinner View -->
    <ng-container *ngIf="spinnerSubject | async">
      <div class="loading-screen-content">
        <ion-spinner name="circles" data-cy="loading-screen-icon"></ion-spinner>
        <p class="loading-screen-message" data-cy="loading-screen-message">
          {{ (!!message)? message:'' }}
        </p>
      </div>
    </ng-container>

    <!-- Desktop No Products -->
    <ng-template #showNoProductTemplateDesktop>
      <ion-grid
        [class.display]="(spinnerSubject | async) === true"
        [fixed]="true"
      >
        <ion-row id="desktop-no-products">
          <ion-col size="12">
            <div class="header-wrapper">
              <app-breadcrumbs
                *ngIf="(orderService.restrictNavigationForCurrentOrder$ | async) !== true"
                [breadcrumbs]="breadcrumbs"
              ></app-breadcrumbs>
              <h1 data-cy="review-order-page-title">
                {{'i18n.orderPage.reviewOrder' | translate}}
              </h1>
            </div>

            <h3 class="page-subtitle page-custom-margin">
              <ng-container
                *ngIf="vm?.orderItemState?.tallies?.totalItems > 0 else showNoPriceTemplateDesktop"
              >
                <span translate data-cy="total-price-with-items"
                  >{{'i18n.orderPage.total'}}</span
                >&nbsp;
                <span data-cy="total-price-number-with-items"
                  >{{ (totalPrice$ | async) | currency }}NO</span
                >
              </ng-container>
              <ng-template #showNoPriceTemplateDesktop>
                <div class="no-price-order-subtitles">
                  <div *ngIf="vm?.hasOrder">
                    <span translate>
                      {{'i18n.orderPage.usFoodsSubtitleOrderDeliveryDate'}} </span
                    >&nbsp;
                    <span>
                      {{ requestedDeliveryDate | date:'M/d/yyyy':'GMT' }}
                    </span>
                    <br />
                  </div>
                  <span translate data-cy="total-price-zero-items">
                    {{'i18n.orderPage.total'}} </span
                  >&nbsp;
                  <span translate data-cy="total-price-number-zero-items">
                    {{ 'i18n.orderPage.zero$'}}
                  </span>
                </div>
                <br />
              </ng-template>
            </h3>
            <!-- For future stories-->
            <!-- <ion-button translate shape="round" fill="outline">{{'i18n.orderPage.quickEntryBtn'}}</ion-button> -->
          </ion-col>
        </ion-row>
        <ion-row id="without-products-desktop">
          <ion-col size="12">
            <h3>
              <span translate> {{'i18n.orderPage.withoutProductsMsg'}} </span>
            </h3>
            <div *ngIf="vm?.hasOrder">
              <ion-button
                data-cy="start-order-button"
                translate
                class="usf-fill-green-button"
                (click)="redirectTo('lists')"
                id="review-order-btn"
              >
                {{'i18n.orderPage.goToMyListBtn'}}
              </ion-button>

              <ion-button
                data-cy="start-order-button"
                translate
                class="usf-outline-green-button"
                (click)="redirectTo('search')"
                id="search-order-btn"
              >
                {{'i18n.orderPage.addProductsBtn'}}
              </ion-button>
            </div>
            <div *ngIf="!vm?.hasOrder">
              <ion-button
                data-cy="start-order-button"
                translate
                class="usf-fill-green-button"
                (click)="redirectTo('lists')"
              >
                {{'i18n.orderPage.startOrderBtn'}}
              </ion-button>
            </div>
            <ion-row>
              <ion-button
                data-cy="cancel-order-button"
                fill="clear"
                [hidden]="userAccessRole$ | async"
                class="usf-outline-orange-button cancel-button-desktop"
                (click)="deleteOrderModal()"
                translate
                id="cancel-order-btn"
              >
                {{'i18n.orderPage.cancelOrder'}}
              </ion-button>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-template>

    <ng-container
      *ngIf="vm?.orderItemState?.tallies?.totalItems > 0 else showNoProductTemplateDesktop"
    >
      <ion-grid
        [fixed]="true"
        [class.display]="(spinnerSubject | async) === true"
      >
        <div class="header-wrapper">
          <ion-row>
            <ion-col size="8">
              <app-breadcrumbs
                *ngIf="(orderService.restrictNavigationForCurrentOrder$ | async) !== true"
                [breadcrumbs]="breadcrumbs"
              ></app-breadcrumbs>
            </ion-col>
            <ion-col size="4" class="right-align-column">
              <ng-container>
                <ion-button
                  class="btn-download"
                  data-cy="download-order-button"
                  (click)="showDownloadCartModal(true)"
                  fill="clear"
                >
                  <ion-icon name="download-outline"></ion-icon>
                  {{'i18n.orderPage.download' | translate}}
                </ion-button>
              </ng-container>
              <ng-container>
                <ion-button
                  class="btn-print"
                  data-cy="print-order-button"
                  (click)="printOrder()"
                  fill="clear"
                >
                  <ion-icon name="print-outline"></ion-icon>
                  {{ 'i18n.orderPage.print' | translate }}
                </ion-button>
              </ng-container>
              <ng-container>
                <ion-button
                  class="btn-share"
                  data-cy="share-order-button"
                  (click)="shareOrder()"
                  fill="clear"
                >
                  <ion-icon name="share-social-outline"></ion-icon>
                  {{ 'i18n.orderPage.share' | translate }}
                </ion-button>
              </ng-container>
            </ion-col>
          </ion-row>
          <ion-row>
            <div class="review-order-page-title-wrapper">
              <h1 data-cy="review-order-page-title">
                {{'i18n.orderPage.reviewOrder' | translate}}
              </h1>
              <div
                class="copied-from-text"
                *ngIf="!!vm?.orderHeader?.copiedFromTandemOrder"
              >
                <span>{{ 'i18n.orderPage.copiedFromOrder' | translate }}</span>
                <span>{{vm?.orderHeader?.copiedFromTandemOrder}}</span>
              </div>
            </div>
          </ion-row>
        </div>
        <ion-row>
          <ion-col
            size-xl="9"
            size-lg="9"
            size-md="8"
            size-sm="9"
            size-xs="9"
            class="left-col"
          >
            <div class="background-section">
              <ion-row class="row-review-order-info">
                <ion-col translate size="12">
                  <!-----------------------START: DYF BANNER-DESKTOP---------------------------->
                  <ng-container
                    *ngIf="vm?.dyfProducts?.length > 0 && !editingVSOrder"
                  >
                    <div
                      class="wrapper dyf-wrapper"
                      *appShowSplit="[dyfFeatureFlagName]"
                    >
                      <div class="content">
                        <h2 data-cy="did-you-forget-title">
                          {{'i18n.orderPage.didYouForget' | translate}}
                        </h2>
                        <p data-cy="dyf-item-number-text">
                          {{vm?.totalDyfProducts + ' '+
                          ('i18n.orderPage.featuredProducts' | translate)}}
                        </p>
                      </div>

                      <div class="tiles">
                        <ng-container
                          *ngFor="let dyfProductInfo of vm?.dyfProducts; let i = index;"
                        >
                          <div>
                            <ion-card
                              class="tile-container"
                              (click)="navigateToDYFPage(i, dyfProductInfo?.product?.productNumber)"
                            >
                              <img
                                _ngcontent-cnw-c347=""
                                src="{{dyfProductInfo?.imageUrl}}"
                              />
                              <div
                                data-cy="mobile-no-image-icon"
                                class="no-image-container"
                                *ngIf="!dyfProductInfo?.imageUrl"
                                [attr.data-cy]="'mobile-dyf-product-' + dyfProductInfo?.product?.productNumber + '-image'"
                              >
                                <ion-icon name="restaurant"></ion-icon>
                              </div>

                              <div class="swiper-product-descriptions">
                                {{dyfProductInfo?.product?.summary?.productDescTxtl
                                | acronymTitleCase}}
                              </div>
                            </ion-card>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <!-----------------------END: DYF BANNER-DESKTOP------------------------------>
                  <!-----------------------START: INSPIRED PICKS BANNER-DESKTOP----------------->
                  <ng-container
                    *ngIf="vm?.inspiredPickProducts?.products?.length > 0 && !editingVSOrder"
                  >
                    <ng-container
                      *ngIf="!dyfFeatureFlagName||vm?.dyfProducts?.length === 0 "
                    >
                      <div
                        class="wrapper dyf-wrapper"
                        *appShowSplit="[inspiredPicksFeatureFlagName]"
                      >
                        <div class="content">
                          <h2
                            class="inspiredPickDisplayTextDesktop"
                            data-cy="inspired-picks-header-desktop-text"
                          >
                            {{vm?.inspiredPickProducts?.displayText.headerTextDesktop}}
                          </h2>
                        </div>
                        <div class="tiles">
                          <ng-container
                            *ngFor="let inspiredPickProductsInfo of vm?.inspiredPickProducts?.products; let i = index;"
                          >
                            <div>
                              <ion-card
                                class="tile-container"
                                (click)="navigateToDYFPageFromInspiredPicks(i, inspiredPickProductsInfo?.product?.productNumber)"
                              >
                                <img
                                  _ngcontent-cnw-c347=""
                                  src="{{inspiredPickProductsInfo?.imageUrl}}"
                                  [attr.data-cy]="
                                          'inspired-pick-product-' + inspiredPickProductsInfo?.product?.productNumber + '-image'
                                        "
                                />
                                <div
                                  class="no-image-container"
                                  *ngIf="!inspiredPickProductsInfo?.imageUrl"
                                  data-cy="inspired-pick-no-image-icon"
                                >
                                  <ion-icon name="restaurant"></ion-icon>
                                </div>
                                <div
                                  class="swiper-product-descriptions"
                                  [attr.data-cy]="
                                        'inspired-pick-product-' + inspiredPickProductsInfo?.product?.productNumber + '-description'
                                        "
                                >
                                  {{inspiredPickProductsInfo?.product?.summary?.productDescTxtl
                                  | acronymTitleCase}}
                                </div>
                              </ion-card>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <!---------------- END: INSPIRED PICKS BANNER-DESKTOP ------------------------>

                  <!---------------- START: top sellers ZONE BANNER-DESKTOP -------------------------->
                  <ng-container
                    *ngIf="
                      !editingVSOrder &&
                      vm?.dyfProducts?.length === 0 &&
                      vm?.inspiredPickProducts?.products?.length === 0 &&
                      vm?.merchZoneProducts?.length > 0
                    "
                  >
                    <div class="wrapper dyf-wrapper">
                      <div class="content merchZoneDisplayTextDesktop">
                        <h2
                          class="merchZoneTitle"
                          data-cy="review-order-merch-zone-title"
                        >
                          {{'i18n.orderPage.topSellers' | translate}}
                        </h2>
                        <p data-cy="review-order-merch-zone-subtitle">
                          {{'i18n.orderPage.dontMissOut' | translate}}
                        </p>
                      </div>
                      <div class="tiles">
                        <ng-container
                          *ngFor="let newTopSeller of vm.merchZoneProducts; let i = index;"
                        >
                          <div>
                            <ion-card
                              class="tile-container"
                              (click)="navigateToDYFPageFromMerchZone(i, newTopSeller?.product?.productNumber)"
                            >
                              <img
                                _ngcontent-cnw-c347=""
                                *ngIf="!!newTopSeller?.product?.imageThumbnail"
                                src="{{newTopSeller?.product?.imageThumbnail}}"
                                [attr.data-cy]="
                                  'review-order-merch-zone-product-image-' + i
                                "
                              />
                              <div
                                class="no-image-container"
                                *ngIf="!newTopSeller?.product?.imageThumbnail"
                                [attr.data-cy]="
                                  'review-order-merch-zone-product-no-image-icon-' + i
                                "
                              >
                                <ion-icon name="restaurant"></ion-icon>
                              </div>
                              <div
                                class="swiper-product-descriptions"
                                [attr.data-cy]="
                                  'review-order-merch-zone-product-description-' + i
                                "
                              >
                                {{newTopSeller?.product?.summary?.productDescTxtl
                                | acronymTitleCase}}
                              </div>
                            </ion-card>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <!---------------- END: top sellers ZONE BANNER-DESKTOP ---------------------------->
                  <!-------------------Start: Direct Shipping Saving Box- Desktop--------------->
                  <ng-container
                    *ngIf="isShipmentTypeVendor; else checkProntoBanner"
                  >
                    <div
                      class="direct-review-box"
                      data-cy="direct-review-container"
                    >
                      <h3 data-cy="direct-review-title">
                        {{'i18n.orderPage.orderDirectShipments1' | translate}}
                        <span
                          >{{'i18n.orderPage.orderDirectShipments2' |
                          translate}}</span
                        >
                        {{'i18n.orderPage.orderDirectShipments3' | translate}}
                      </h3>
                      <ion-row>
                        <ion-col size="10">
                          <div class="direct-review-content">
                            <h5
                              data-cy="direct-review-savings"
                              *ngIf="this.vm?.orderTallies?.totalDirectShipmentSavings > 0"
                            >
                              {{'i18n.orderPage.savingYou1' | translate}}
                              {{this.vm?.orderTallies?.totalDirectShipmentSavings
                              | currency : '$':'symbol':'1.2-2'}}
                              {{'i18n.orderPage.savingYou2' | translate}}
                            </h5>
                            <p
                              *appShowSplit="[directAllowReturnsFlagName]"
                              data-cy="direct-review-text"
                            >
                              {{'i18n.orderPage.directShipmentFreightMsg' |
                              translate}}
                            </p>
                            <p
                              *appHideSplit="[directAllowReturnsFlagName]"
                              data-cy="direct-review-text"
                            >
                              {{'i18n.orderPage.directShipmentFreightMsgLine1' |
                              translate}}
                              <strong translate
                                >{{'i18n.orderPage.directShipmentFreightMsgLine2'}}</strong
                              >
                              {{'i18n.orderPage.directShipmentFreightMsgLine3' |
                              translate }}
                            </p>
                          </div>

                          <p data-cy="direct-review-link">
                            <a
                              class="jump-to-direct-orders-desktop"
                              (click)="scrollToElement('direct-orders-desktop')"
                              >{{'i18n.orderPage.jumpToDirectOrders' |
                              translate}}
                            </a>
                          </p>

                          <ng-container
                            *appShowSplit="[orderDeliveryInstFeatureFlagName]"
                          >
                            <p class="addl-instructions-link">
                              <ng-container
                                *ngIf="vm?.additionalDeliveryInstructions?.length > 0; else showAddLabel"
                              >
                                <b
                                  >{{ 'i18n.orderPage.addlInstructions' |
                                  translate }}:</b
                                >
                                {{ vm?.additionalDeliveryInstructions }}
                                <a (click)="showAddlInstructionsModal(true)"
                                  >{{ 'i18n.common.edit' | translate }}
                                </a>
                              </ng-container>
                              <ng-template #showAddLabel>
                                <b
                                  >{{ 'i18n.orderPage.addlInstructions' |
                                  translate }}:
                                </b>
                                <a (click)="showAddlInstructionsModal(true)"
                                  >{{ 'i18n.common.add' | translate }}
                                </a>
                              </ng-template>
                            </p>
                          </ng-container>
                        </ion-col>

                        <ion-col size="2">
                          <img
                            data-cy="direct-review-icon"
                            src="assets/images/direct-box.svg"
                          />
                        </ion-col>
                      </ion-row>
                    </div>
                  </ng-container>
                  <!----------- /END: Direct Shipping Saving Box- Desktop------------>
                  <ng-container *ngIf="selectedCustomer?.autoSubProducts">
                    <h5 class="auto-sub">
                      {{'i18n.orderPage.autoSubMessage' | translate}}
                    </h5>
                  </ng-container>
                  <!-------------------Start: Pronto Banner - Desktop--------------->
                  <ng-template #checkProntoBanner>
                    <div
                      class="pronto-banner"
                      data-cy="pronto-banner-container"
                      *ngIf="(vm?.orderHeader?.orderStatus === orderStatusEnum.IN_PROGRESS ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS) &&
                              checkedForValidRequestedDeliveryDate &&
                              checkedForValidProntoDeliveryDate"
                    >
                      <ion-row>
                        <ion-col size="7">
                          <div class="pronto-banner-content">
                            <h3 data-cy="pronto-banner-title">
                              {{'i18n.orderPage.prontoBannerTitle' | translate}}
                            </h3>
                          </div>
                        </ion-col>

                        <ion-col offset="3" size="2">
                          <img
                            data-cy="pronto-banner-icon"
                            src="assets/images/truck-pronto.png"
                          />
                        </ion-col>
                      </ion-row>
                    </div>
                  </ng-template>
                  <!----------- /END: Pronto Banner - Desktop------------>
                </ion-col>
                <!-- START AUTOSUB MESSAGE -->
              </ion-row>

              <!-- PRODUCTS LIST -->
              <ng-container
                *ngIf="vm?.orderItemState?.tallies?.totalItems > 0  else showNoProductTemplateDesktop"
              >
                <!-- UNUSUAL QUANTITIES -->
                <ng-container
                  *ngIf="this.vm?.online && vm?.uqeCards?.length > 0"
                >
                  <ion-accordion-group value="unusual-quantity">
                    <ion-accordion
                      value="unusual-quantity"
                      class="accordion-unusual-qty"
                    >
                      <ion-item
                        id="no-ripple"
                        class="gray-content-bg accordion-main-row"
                        slot="header"
                      >
                        <div class="accordion-wrapper">
                          <h3>
                            {{ 'i18n.orderPage.unusualQuantities' | translate }}
                            ({{vm?.uqeCards?.length}})
                          </h3>
                          <div class="accordion-subtitle-info">
                            {{'i18n.orderPage.unusualQuantitiesNote' | translate
                            }}
                          </div>
                        </div>
                      </ion-item>
                      <div
                        class="gray-content-bg add-padding"
                        slot="content"
                        tabindex="0"
                        id="ionHeader"
                      ></div>
                      <div
                        class="gray-content-bg cards-container"
                        slot="content"
                        tabindex="0"
                        id="ionHeader"
                      >
                        <div
                          *ngFor="let uqeCard of vm?.uqeCards; trackBy: trackByIndex; last as lastItem; let i = index"
                        >
                          <app-usf-product-card-desktop
                            [vm]="uqeCard"
                            (quantityUpdateEmitter)="quantityUpdateHandler($event)"
                            (ellipsisEmitter)="openProductCardEllipsis($event)"
                            (productCardClickEmitter)="clickCard($event)"
                            (infoIconClickEmitter)="openProductStatus($event)"
                            (confirmQuantityEmitter)="confirmUnusualQuantity($event)"
                          ></app-usf-product-card-desktop>
                        </div>
                      </div>
                    </ion-accordion>
                  </ion-accordion-group>
                </ng-container>
                <div
                  data-cy="order-cart-search-sort-filter-section"
                  class="search-sort-filter-section"
                >
                  <div class="search-container">
                    <ion-searchbar
                      id="list-search-bar--0"
                      data-cy="list-detail-searchbar"
                      class="search"
                      mode="md"
                      placeholder="{{ 'i18n.orderPage.searchWithinYourCart' | translate}}"
                      [(ngModel)]="searchKey"
                      (ionInput)="orderItemSearch()"
                    >
                    </ion-searchbar>
                  </div>
                </div>
                <ng-container
                  *ngFor="let shipment of vm?.shipments; trackBy: trackByIndex; let shipmentIndex = index"
                >
                  <ion-accordion-group value="shipment">
                    <ion-accordion value="shipment">
                      <ion-item
                        id="no-ripple"
                        class="gray-content-bg accordion-main-row"
                        slot="header"
                      >
                        <div class="accordion-wrapper">
                          <div class="shipment-info-row">
                            <div class="shipping-title-section">
                              <h3
                                *ngIf="shipment.shipmentType === 'routed'"
                                translate
                                data-cy="shipping-title-routed-delivery"
                              >
                                <ng-container
                                  *ngIf="isProntoDay(
                                    !dateChange &&
                                      (vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED ||
                                        vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD ||
                                        vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS) ?
                                    vm?.orderHeader?.confirmedDeliveryDate?.toString() :
                                    shipment?.deliveryDate?.toString()); else originalHeader"
                                >
                                  {{ 'i18n.orderPage.prontoOrderDeliveryDesktop'
                                  | translate }}
                                </ng-container>
                                <ng-template #originalHeader>
                                  {{ 'i18n.orderPage.routedOrderDeliveryDesktop'
                                  }}
                                </ng-template>
                                <span
                                  *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                                >
                                  {{vm?.usfOrderDeliveryDate |
                                  date:'M/d/yyyy':'GMT'}}
                                </span>
                                <span
                                  *ngIf="!nextDeliveryInfo?.creditIndicator"
                                  translate
                                >
                                  {{ 'i18n.orderPage.notApplicable' }}
                                </span>
                              </h3>

                              <h3
                                *ngIf="shipment.shipmentType === 'vendor'"
                                translate
                                data-cy="shipping-title-vendor-delivery"
                                id="direct-orders-desktop"
                                #vendorShipLabel
                              >
                                {{'i18n.orderPage.vendorOrderDeliveryDesktop'}}
                                <span
                                  *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                                  >{{shipment.deliveryDate |
                                  date:'M/d/yyyy':'GMT'}}
                                </span>
                                <span
                                  *ngIf="!nextDeliveryInfo?.creditIndicator"
                                  translate
                                >
                                  {{ 'i18n.orderPage.notApplicable' }}
                                </span>
                              </h3>
                              <div class="accordion-subtitle-info">
                                <div data-cy="product-info-text">
                                  {{'i18n.orderPage.totalProducts' | translate}}
                                  {{shipment?.cartItems?.length}}
                                  <span class="mini-border">|</span>
                                  {{'i18n.orderPage.totalCases/Eaches' |
                                  translate}}
                                  {{shipment?.shipmentTallies?.totalCases}}
                                  {{'i18n.orderPage.cs' | translate}} /
                                  {{shipment?.shipmentTallies?.totalEaches}}
                                  {{'i18n.orderPage.ea' | translate}}
                                  <ng-container
                                    *ngIf="shipment.shipmentType === 'routed'"
                                  >
                                    <span class="mini-border">|</span>
                                    {{'i18n.orderPage.orderWeight' | translate}}
                                    {{shipment?.shipmentTallies?.orderWeight |
                                    number :'1.1-2'}} {{'i18n.orderPage.lb' |
                                    translate}}
                                  </ng-container>
                                </div>
                              </div>
                              <div
                                class="vendor-information"
                                *ngIf="shipment.shipmentType === 'vendor'"
                              >
                                <p
                                  *ngIf="!editingVSOrder"
                                  data-cy="buy-and-save"
                                >
                                  <a (click)="goToDirect($event)"
                                    >{{ "i18n.orderPage.buyMoreSave" | translate
                                    }}</a
                                  >
                                  {{ "i18n.orderPage.increaseQuantity" |
                                  translate }}
                                </p>
                                <!-- DELIVERY INSTRUCTIONS -->
                                <p
                                  *ngIf="vm?.additionalDeliveryInstructions"
                                  data-cy="delivery-instructions"
                                >
                                  <b
                                    >{{ 'i18n.orderPage.addlInstructions' |
                                    translate }}:</b
                                  >
                                  {{ vm?.additionalDeliveryInstructions }}
                                </p>
                              </div>
                            </div>

                            <div
                              class="shipment-date-and-total"
                              *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                            >
                              <div class="savings-text">
                                <div>
                                  <ng-container
                                    *ngIf="selectedCustomer?.ogPrintPriceInd !== 'N' else noPriceCustomer"
                                  >
                                    <div
                                      data-cy="total-savings-price-text"
                                      class="total-savings-text"
                                    >
                                      {{shipment.shipmentTallies?.totalPrice |
                                      currency}}
                                    </div>
                                  </ng-container>

                                  <ng-template #noPriceCustomer>
                                    <div data-cy="total-savings-not-applicable">
                                      <span class="total-savings-text-label">
                                        {{ 'i18n.orderPage.total' | translate}}
                                      </span>
                                      <span class="total-savings-text">
                                        {{'i18n.orderPage.notApplicable' |
                                        translate}}
                                      </span>
                                    </div>
                                  </ng-template>
                                  <div
                                    data-cy="shipping-savings-text"
                                    class="total-shipping-savings-text"
                                    *ngIf="shipment.shipmentType === 'vendor' && shipment?.shipmentTallies?.totalDirectShipmentSavings"
                                  >
                                    {{'i18n.orderPage.shippingSavings' |
                                    translate}}
                                    {{shipment?.shipmentTallies?.totalDirectShipmentSavings
                                    || 0 | currency : '$':'symbol':'1.2-2'}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                          >
                            <ion-button
                              data-cy="change-date-button"
                              translate
                              *ngIf="vm?.hasOrder && shipment?.shipmentType === 'routed'"
                              class="usf-green-link-button calendar-button"
                              (click)="presentCalendarPopover($event)"
                            >
                              {{'i18n.orderPage.changeDate'}}
                              <ion-icon
                                data-cy="calendar-icon"
                                class="calendar-icon"
                                name="calendar-outline"
                              ></ion-icon>
                            </ion-button>
                          </div>
                        </div>
                      </ion-item>
                      <div
                        class="gray-content-bg cards-container"
                        slot="content"
                        tabindex="0"
                        id="ionHeader"
                      >
                        <div
                          *ngIf="shipment?.containsItemBeingFiltered; else noResultsFound"
                        >
                          <div
                            *ngFor="let cartItem of shipment?.cartItems; trackBy: trackByIndex; last as lastItem; let i = index"
                          >
                            <ng-container
                              *ngIf="shipment?.shipmentType === shipmentTypeEnum.vendor ||  !isAlternative(cartItem) || !parentHasQuantity(cartItem)"
                            >
                              <app-usf-product-card-desktop
                                [vm]="shipment?.productCardVms[i]"
                                (quantityUpdateEmitter)="quantityUpdateHandler($event)"
                                (ellipsisEmitter)="openProductCardEllipsis($event)"
                                (productCardClickEmitter)="clickCard($event)"
                                (infoIconClickEmitter)="openProductStatus($event)"
                                [hidden]="!cartItem.matchesSearchFilter"
                              ></app-usf-product-card-desktop>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <ng-template #noResultsFound>
                        <ion-card>
                          <ion-card-content class="no-result-found-text">
                            {{'i18n.orderPage.noProductsWereFound' | translate}}
                          </ion-card-content>
                        </ion-card>
                      </ng-template>
                    </ion-accordion>
                  </ion-accordion-group>
                </ng-container>
                <app-deals-banner
                  *ngIf="!vm?.frequentlyBoughtTogetherProducts?.isFeatureEnabled && !editingVSOrder"
                  [bannerStyle]="bannerStyle"
                  [buttonLink]="dealsUrl"
                  [observeAfterLoadedElement]="'#desktop ion-accordion-group'"
                >
                </app-deals-banner>
                <app-merchandising-product-carousel
                  *ngIf="vm?.frequentlyBoughtTogetherProducts?.isFeatureEnabled &&
                    vm?.frequentlyBoughtTogetherProducts?.products?.length > 0 &&
                    !editingVSOrder
                  "
                  observeIntersection
                  class="product-carousel desktop"
                  [platformType]="platformService?.platformType"
                  [title]="vm?.frequentlyBoughtTogetherProducts?.displayText | translate"
                  [products]="vm?.frequentlyBoughtTogetherProducts?.products"
                  (quantityUpdateEmitter)="onFrequentlyBoughtTogetherQuantityUpdate($event.quantityUpdate, $event.index, $event.product)"
                  [linkSource]="frequentlyBoughtTogetherLnkSrc"
                  [merchFeature]="FREQUENTLY_BOUGHT_TOGETHER_FEATURE_NAME"
                  [addMethod]="FREQUENTLY_BOUGHT_TOGETHER_FEATURE_NAME"
                  [observeAfterLoadedElement]="'#desktop ion-accordion-group'"
                  (startObservation)="onFrequentlyBoughtTogetherStartObservation()"
                  (impression)="onFrequentlyBoughtTogetherView()"
                >
                </app-merchandising-product-carousel>

                <ion-row>
                  <ion-col>
                    <p
                      data-cy="price-info-message-text"
                      translate
                      *ngIf="vm?.shipments?.length >= 1"
                      class="micro-text"
                    >
                      {{'i18n.orderPage.priceInfoMsg'}}
                    </p>
                  </ion-col>
                </ion-row>
              </ng-container>
            </div>
          </ion-col>
          <ion-col size-xl="3" size-lg="3" size-md="4" size-sm="3" size-xs="3">
            <app-order-info-sidebar
              [platform]="platformService?.platformType"
              [orderHeader]="vm?.orderHeader"
              [orderItemTallies]="vm?.orderItemState?.tallies"
              [isList]="false"
              [isCart]="true"
              [shippingSavings]="vm?.orderTallies?.totalDirectShipmentSavings"
              [isOnMinimumOrderMetFlag]="isOnMinimumOrderMetFlag"
              [isShipmentTypeVendor]="isShipmentTypeVendor"
              [orderMinVm]="orderMinVm"
              [submitButtonText]="vm?.submitButtonText"
              [disableSubmit]="vm?.disableSubmit"
              (submitOrder)="submitOrder($event)"
              (changeDeliveryDate)="presentCalendarPopover($event)"
              (cancelOrder)="deleteOrderModal()"
              (printOrder)="printOrder()"
              (shareOrder)="shareOrder()"
              (downloadOrder)="showDownloadCartModal(true)"
            >
            </app-order-info-sidebar>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-container>
    <app-footer *ngIf="!editingVSOrder"></app-footer>
  </div>

  <!-- TOUCH -->
  <div
    *ngIf="(this.platformService?.isTouchExperience$ | async)"
    class="touch-wrapper"
  >
    <ng-container *ngIf="spinnerSubject | async">
      <div class="loading-screen-content">
        <ion-spinner name="circles" data-cy="loading-screen-icon"></ion-spinner>
        <p class="loading-screen-message" data-cy="loading-screen-message">
          {{ (!!message)? message:'' }}
        </p>
      </div>
    </ng-container>

    <div id="tablet" [class.display]="(spinnerSubject | async) === true">
      <ion-grid [fixed]="true">
        <ng-template #showNoProductTemplateTablet>
          <!-- Tablet No Products -->
          <ion-row id="tablet-no-products">
            <ion-col size="12">
              <div class="header-section" data-cy="tablet-header-title">
                <h2
                  data-cy="review-order-heading"
                  translate
                  class="page-title-oswald"
                >
                  {{'i18n.orderPage.reviewOrder' | translate}}
                </h2>
                <h3 class="page-subtitle page-custom-margin">
                  <div class="no-price-order-subtitles">
                    <div *ngIf="vm?.hasOrder">
                      <span translate>
                        {{'i18n.orderPage.usFoodsSubtitleOrderDeliveryDate'}} </span
                      >&nbsp;
                      <span>
                        {{ requestedDeliveryDate | date:'M/d/yyyy':'GMT' }}
                      </span>
                      <br />
                    </div>
                    <span translate data-cy="total-price-zero-items">
                      {{'i18n.orderPage.total'}} </span
                    >&nbsp;
                    <span translate data-cy="total-price-number-zero-items">
                      {{ 'i18n.orderPage.zero$'}}
                    </span>
                  </div>
                  <br />
                </h3>
              </div>
            </ion-col>
          </ion-row>
          <ion-row id="without-products">
            <ion-col size="12">
              <h3>
                <span translate> {{'i18n.orderPage.withoutProductsMsg'}} </span>
              </h3>
              <div *ngIf="vm?.hasOrder">
                <ion-button
                  data-cy="start-order-button"
                  translate
                  class="usf-fill-green-button"
                  (click)="redirectTo('lists')"
                  id="review-order-btn"
                >
                  {{'i18n.orderPage.goToMyListBtn'}}
                </ion-button>

                <ion-button
                  data-cy="start-order-button"
                  translate
                  class="usf-outline-green-button"
                  (click)="redirectTo('search')"
                  id="search-order-btn"
                >
                  {{'i18n.orderPage.addProductsBtn'}}
                </ion-button>
              </div>
              <div *ngIf="!vm?.hasOrder">
                <ion-button
                  data-cy="start-order-button"
                  translate
                  class="usf-fill-green-button"
                  (click)="redirectTo('lists')"
                >
                  {{'i18n.orderPage.startOrderBtn'}}
                </ion-button>
              </div>
              <ion-row>
                <ion-button
                  data-cy="cancel-order-button"
                  fill="clear"
                  [hidden]="userAccessRole$ | async"
                  class="usf-outline-orange-button cancel-button"
                  (click)="deleteOrderModal()"
                  translate
                  id="cancel-order-btn"
                >
                  {{'i18n.orderPage.cancelOrder'}}
                </ion-button>
              </ion-row>
            </ion-col>
          </ion-row>
        </ng-template>

        <ng-container
          *ngIf="vm?.orderItemState?.tallies?.totalItems > 0 else showNoProductTemplateTablet"
        >
          <ion-row>
            <ion-col size="8">
              <div class="section">
                <h2
                  translate
                  class="tablet-title"
                  data-cy="tablet-review-order-heading"
                >
                  {{'i18n.orderPage.reviewOrder' | translate}}
                </h2>
                <div
                  class="copied-from-text"
                  *ngIf="!!vm?.orderHeader?.copiedFromTandemOrder"
                >
                  <span
                    >{{ 'i18n.orderPage.copiedFromOrder' | translate }}</span
                  >
                  <span>{{vm?.orderHeader?.copiedFromTandemOrder}}</span>
                </div>
                <!-----------------------START: DYF BANNER-TABLET---------------------------->
                <ion-row class="dyf-row-wrapper">
                  <ng-container
                    *ngIf="vm?.dyfProducts?.length > 0 && !editingVSOrder"
                  >
                    <ion-col
                      class="wrapper dyf-wrapper"
                      *appShowSplit="[dyfFeatureFlagName]"
                    >
                      <div class="content">
                        <h2 data-cy="tablet-dyf-title">
                          {{'i18n.orderPage.didYouForget' | translate}}
                        </h2>
                        <p data-cy="tablet-dyf-description">
                          {{vm?.totalDyfProducts + ' '+
                          ('i18n.orderPage.featuredProducts' | translate)}}
                        </p>
                      </div>

                      <div class="tiles">
                        <ng-container
                          *ngFor="let dyfProductInfo of vm?.dyfProducts; let i = index;"
                        >
                          <div>
                            <ion-card
                              class="tile-container"
                              (click)="navigateToDYFPage(i, dyfProductInfo?.product?.productNumber)"
                            >
                              <img
                                _ngcontent-cnw-c347=""
                                src="{{dyfProductInfo?.imageUrl}}"
                                [attr.data-cy]="'dyf-product-' + dyfProductInfo?.product?.productNumber + '-title'"
                              />
                              <div
                                class="no-image-container"
                                *ngIf="!dyfProductInfo?.imageUrl"
                                data-cy="tablet-no-image-icon"
                              >
                                <ion-icon name="restaurant"></ion-icon>
                              </div>

                              <div
                                class="swiper-product-descriptions"
                                [attr.data-cy]="'dyf-product-' + dyfProductInfo?.product?.productNumber + '-description'"
                              >
                                {{dyfProductInfo?.product?.summary?.productDescTxtl
                                | acronymTitleCase}}
                              </div>
                            </ion-card>
                          </div>
                        </ng-container>
                      </div>
                    </ion-col>
                  </ng-container>
                  <!-----------------------END: DYF BANNER-TABLET---------------------------->
                  <!----Start: INSPIRED PICK BANNER - TABLET---->
                  <ng-container
                    *ngIf="vm?.inspiredPickProducts?.products?.length > 0 && !editingVSOrder"
                  >
                    <ng-container
                      *ngIf="!dyfFeatureFlagName||vm?.dyfProducts?.length === 0 "
                    >
                      <ion-col
                        class="wrapper dyf-wrapper"
                        *appShowSplit="[inspiredPicksFeatureFlagName]"
                      >
                        <div class="content">
                          <h2
                            class="inspiredPickDisplayTextTablet"
                            data-cy="inspired-picks-header-tablet-text"
                          >
                            {{vm?.inspiredPickProducts?.displayText.headerTextMobile}}
                          </h2>
                        </div>

                        <div class="tiles">
                          <ng-container
                            *ngFor="let inspiredPickProductsInfo of vm?.inspiredPickProducts?.products; let i = index;"
                          >
                            <div>
                              <ion-card
                                class="tile-container"
                                (click)="navigateToDYFPageFromInspiredPicks(i, inspiredPickProductsInfo?.product?.productNumber)"
                              >
                                <img
                                  _ngcontent-cnw-c347=""
                                  src="{{inspiredPickProductsInfo?.imageUrl}}"
                                  [attr.data-cy]="
                                    'inspired-pick-product-' + inspiredPickProductsInfo?.product?.productNumber + '-image'
                                    "
                                />
                                <div
                                  class="no-image-container"
                                  *ngIf="!inspiredPickProductsInfo?.imageUrl"
                                  data-cy="inspired-pick-no-image-icon"
                                >
                                  <ion-icon name="restaurant"></ion-icon>
                                </div>

                                <div class="swiper-product-descriptions">
                                  {{inspiredPickProductsInfo?.product?.summary?.productDescTxtl
                                  | acronymTitleCase}}
                                </div>
                              </ion-card>
                            </div>
                          </ng-container>
                        </div>
                      </ion-col>
                    </ng-container>
                  </ng-container>
                  <!----END: INSPIRED PICK BANNER - TABLET----------->

                  <!---------------- START: top sellers ZONE BANNER-TABLET --------------------------->
                  <ng-container
                    *ngIf="
                      !editingVSOrder &&
                      vm?.dyfProducts?.length === 0 &&
                      vm?.inspiredPickProducts?.products?.length === 0 &&
                      vm?.merchZoneProducts.length > 0
                    "
                  >
                    <ion-col class="wrapper dyf-wrapper">
                      <div class="content">
                        <h2
                          class="merchZoneTitle"
                          data-cy="review-order-merch-zone-title-tablet"
                        >
                          {{'i18n.orderPage.topSellers' | translate}}
                        </h2>
                        <p
                          class="merchZoneSubTitleTablet"
                          data-cy="review-order-merch-zone-subtitle-tablet"
                        >
                          {{'i18n.orderPage.dontMissOut' | translate}}
                        </p>
                      </div>

                      <div class="tiles">
                        <ng-container
                          *ngFor="let newTopSeller of vm.merchZoneProducts; let i = index;"
                        >
                          <div>
                            <ion-card
                              class="tile-container"
                              (click)="navigateToDYFPageFromMerchZone(i, newTopSeller?.product?.productNumber)"
                            >
                              <img
                                _ngcontent-cnw-c347=""
                                *ngIf="!!newTopSeller?.product?.imageThumbnail"
                                src="{{newTopSeller?.product?.imageThumbnail}}"
                                [attr.data-cy]="
                                  'review-order-merch-zone-product-image-tablet-' + i
                                "
                              />
                              <div
                                class="no-image-container"
                                *ngIf="!newTopSeller?.product?.imageThumbnail"
                                [attr.data-cy]="
                                  'review-order-merch-zone-product-no-image-icon-tablet-' + i
                                "
                              >
                                <ion-icon name="restaurant"></ion-icon>
                              </div>
                              <div
                                class="swiper-product-descriptions"
                                [attr.data-cy]="
                                  'review-order-merch-zone-product-description-tablet-' + i
                                "
                              >
                                {{newTopSeller?.product?.summary?.productDescTxtl
                                | acronymTitleCase}}
                              </div>
                            </ion-card>
                          </div>
                        </ng-container>
                      </div>
                    </ion-col>
                  </ng-container>
                  <!---------------- END: top sellers ZONE BANNER-TABLET ----------------------------->
                </ion-row>

                <ion-row class="row-review-order-info" id="tablet">
                  <ng-container
                    *ngIf="isShipmentTypeVendor; else checkProntoBanner"
                  >
                    <!-----------Start: Direct Shipping Saving Box - Tablet------------>
                    <ion-col size="12">
                      <div
                        class="direct-review-box"
                        data-cy="direct-review-container"
                      >
                        <h3 data-cy="direct-review-title">
                          {{'i18n.orderPage.orderDirectShipments1' | translate}}
                          <span
                            >{{'i18n.orderPage.orderDirectShipments2' |
                            translate}}</span
                          >
                          {{'i18n.orderPage.orderDirectShipments3' | translate}}
                        </h3>
                        <ion-row>
                          <ion-col size="10">
                            <div class="direct-review-content">
                              <h5
                                data-cy="direct-review-savings"
                                *ngIf="this.vm?.orderTallies?.totalDirectShipmentSavings > 0"
                              >
                                {{'i18n.orderPage.savingYou1' | translate}}
                                {{this.vm?.orderTallies?.totalDirectShipmentSavings
                                | currency : '$':'symbol':'1.2-2'}}
                                {{'i18n.orderPage.savingYou2' | translate}}
                              </h5>
                              <p
                                *appShowSplit="[directAllowReturnsFlagName]"
                                data-cy="direct-review-text"
                              >
                                {{'i18n.orderPage.directShipmentFreightMsg' |
                                translate}}
                              </p>
                              <p
                                *appHideSplit="[directAllowReturnsFlagName]"
                                data-cy="direct-review-text"
                              >
                                {{'i18n.orderPage.directShipmentFreightMsgLine1'
                                | translate}}
                                <strong translate
                                  >{{'i18n.orderPage.directShipmentFreightMsgLine2'}}</strong
                                >
                                {{'i18n.orderPage.directShipmentFreightMsgLine3'
                                | translate }}
                              </p>
                            </div>

                            <p data-cy="direct-review-link">
                              <a
                                class="jump-to-direct-orders-tablet"
                                (click)="scrollToElement('direct-orders-tablet')"
                                >{{'i18n.orderPage.jumpToDirectOrders' |
                                translate}}</a
                              >
                            </p>

                            <ng-container
                              *appShowSplit="[orderDeliveryInstFeatureFlagName]"
                            >
                              <p class="addl-instructions-link">
                                <ng-container
                                  *ngIf="vm?.additionalDeliveryInstructions?.length > 0; else showAddLabel"
                                >
                                  <b
                                    >{{ 'i18n.orderPage.addlInstructions' |
                                    translate }}:</b
                                  >
                                  {{ vm?.additionalDeliveryInstructions }}
                                  <a (click)="showAddlInstructionsModal(true)"
                                    >{{ 'i18n.common.edit' | translate }}
                                  </a>
                                </ng-container>
                                <ng-template #showAddLabel>
                                  <b
                                    >{{ 'i18n.orderPage.addlInstructions' |
                                    translate }}:
                                  </b>
                                  <a (click)="showAddlInstructionsModal(true)"
                                    >{{ 'i18n.common.add' | translate }}
                                  </a>
                                </ng-template>
                              </p>
                            </ng-container>
                          </ion-col>

                          <ion-col size="2">
                            <img
                              data-cy="direct-review-icon"
                              src="assets/images/direct-box.svg"
                            />
                          </ion-col>
                        </ion-row>
                      </div>
                    </ion-col>
                    <!----------- /END: Direct Shipping Saving Box- Tablet------------>
                  </ng-container>
                  <ion-row *ngIf="selectedCustomer?.autoSubProducts">
                    <h5 class="auto-sub" id="tablet">
                      {{'i18n.orderPage.autoSubMessage' | translate}}
                    </h5>
                  </ion-row>

                  <!-------------------Start: Pronto Banner- Tablet--------------->
                  <ng-template #checkProntoBanner>
                    <div
                      class="pronto-banner"
                      data-cy="pronto-banner-container"
                      *ngIf="(vm?.orderHeader?.orderStatus === orderStatusEnum.IN_PROGRESS ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS) &&
                              checkedForValidRequestedDeliveryDate &&
                              checkedForValidProntoDeliveryDate"
                    >
                      <ion-row>
                        <ion-col size="12">
                          <div class="pronto-banner-content">
                            <h3 data-cy="pronto-banner-title">
                              {{'i18n.orderPage.prontoBannerTitle' | translate}}
                            </h3>
                          </div>
                        </ion-col>
                      </ion-row>
                    </div>
                  </ng-template>
                  <!----------- /END: Pronto Banner- Tablet------------>
                </ion-row>

                <!-- PRODUCTS LIST -->
                <div
                  *ngIf="vm?.orderItemState?.tallies?.totalItems > 0 else showNoProductTemplateTablet"
                >
                  <!-- UNUSUAL QUANTITIES -->
                  <ng-container
                    *ngIf="this.vm?.online && vm?.uqeCards?.length > 0"
                  >
                    <ion-accordion-group value="unusual-quantity">
                      <ion-accordion
                        value="unusual-quantity"
                        class="accordion-unusual-qty"
                      >
                        <ion-item
                          id="no-ripple"
                          class="gray-content-bg accordion-main-row"
                          slot="header"
                        >
                          <div class="accordion-wrapper">
                            <h3>
                              {{ 'i18n.orderPage.unusualQuantities' | translate
                              }} ({{vm?.uqeCards?.length}})
                            </h3>
                            <div class="accordion-subtitle-info">
                              {{'i18n.orderPage.unusualQuantitiesNote' |
                              translate }}
                            </div>
                          </div>
                        </ion-item>
                        <div
                          class="gray-content-bg add-padding"
                          slot="content"
                          tabindex="0"
                          id="ionHeader"
                        >
                          <div
                            *ngFor="let uqeCard of vm?.uqeCards; trackBy: trackByIndex; last as lastItem; let i = index"
                          >
                            <app-usf-product-card-touch
                              [vm]="uqeCard"
                              (quantityUpdateEmitter)="quantityUpdateHandler($event)"
                              (ellipsisEmitter)="openProductCardEllipsis($event)"
                              (productCardClickEmitter)="clickCard($event)"
                              (infoIconClickEmitter)="openProductStatus($event)"
                              (confirmQuantityEmitter)="confirmUnusualQuantity($event)"
                            ></app-usf-product-card-touch>
                          </div>
                        </div>
                      </ion-accordion>
                    </ion-accordion-group>
                  </ng-container>
                  <div
                    data-cy="order-cart-search-sort-filter-section"
                    class="search-sort-filter-section"
                  >
                    <div class="search-container">
                      <ion-searchbar
                        id="list-search-bar--0"
                        data-cy="list-detail-searchbar"
                        class="search"
                        mode="md"
                        placeholder="{{ 'i18n.orderPage.searchWithinYourCart' | translate}}"
                        [(ngModel)]="searchKey"
                        (ionInput)="orderItemSearch()"
                      >
                      </ion-searchbar>
                    </div>
                  </div>
                  <ng-container
                    *ngFor="let shipment of vm?.shipments; trackBy: trackByIndex; let shipmentIndex = index"
                  >
                    <ion-accordion-group value="shipment">
                      <ion-accordion value="shipment">
                        <ion-item
                          id="no-ripple"
                          class="gray-content-bg accordion-main-row"
                          slot="header"
                        >
                          <div class="shipment-info-row">
                            <div class="shipping-title-section">
                              <h3
                                *ngIf="shipment.shipmentType === 'routed'"
                                translate
                                data-cy="tablet-routed-delivery-text"
                              >
                                <ng-container
                                  *ngIf="isProntoDay(
                                    !dateChange &&
                                      (vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED ||
                                        vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD ||
                                        vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS) ?
                                    vm?.orderHeader?.confirmedDeliveryDate?.toString() :
                                    shipment?.deliveryDate?.toString()); else originalHeader"
                                >
                                  {{ 'i18n.orderPage.prontoOrderDeliveryTouch' |
                                  translate }}
                                </ng-container>
                                <ng-template #originalHeader>
                                  {{ 'i18n.orderPage.routedOrderDeliveryTouch'
                                  }}
                                </ng-template>
                                <span
                                  *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                                >
                                  {{vm?.usfOrderDeliveryDate |
                                  date:'M/d/yyyy':'GMT'}}
                                </span>
                                <span
                                  *ngIf="!nextDeliveryInfo?.creditIndicator"
                                  translate
                                >
                                  {{ 'i18n.orderPage.notApplicable' }}
                                </span>
                              </h3>
                              <h3
                                *ngIf="shipment.shipmentType === 'vendor'"
                                translate
                                data-cy="tablet-vendor-delivery-text"
                                id="direct-orders-tablet"
                              >
                                {{'i18n.orderPage.vendorOrderDeliveryTouch'}}
                                <span
                                  *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                                  >{{shipment.deliveryDate |
                                  date:'M/d/yyyy':'GMT'}}
                                </span>
                                <span
                                  *ngIf="!nextDeliveryInfo?.creditIndicator"
                                  translate
                                >
                                  {{ 'i18n.orderPage.notApplicable' }}
                                </span>
                              </h3>
                              <div>
                                <div class="accordion-subtitle-info">
                                  <div data-cy="tablet-product-info-text">
                                    <div
                                      *ngIf="selectedCustomer?.ogPrintPriceInd !== 'N' else noPriceCustomer"
                                    >
                                      {{shipment.shipmentTallies?.totalPrice |
                                      currency}}
                                    </div>
                                    <span class="mini-border">|</span>
                                    {{shipment?.cartItems?.length}} (
                                    {{shipment?.shipmentTallies?.totalCases}}
                                    {{'i18n.orderPage.cs' | translate}} /
                                    {{shipment?.shipmentTallies?.totalEaches}}
                                    {{'i18n.orderPage.ea' | translate}} )
                                    <ng-container
                                      *ngIf="shipment.shipmentType === 'routed'"
                                    >
                                      <span class="mini-border">|</span>
                                      {{'i18n.orderPage.orderWeight' |
                                      translate}}
                                      {{shipment?.shipmentTallies?.orderWeight |
                                      number :'1.1-2'}} {{'i18n.orderPage.lb' |
                                      translate}}
                                    </ng-container>

                                    <div
                                      *ngIf="shipment.shipmentType === 'vendor' && shipment?.shipmentTallies?.totalDirectShipmentSavings"
                                    >
                                      {{'i18n.orderPage.shippingSavings' |
                                      translate}}
                                      {{shipment?.shipmentTallies?.totalDirectShipmentSavings
                                      || 0 | currency : '$':'symbol':'1.2-2'}}
                                    </div>
                                  </div>
                                  <ng-template #noPriceCustomer>
                                    <div data-cy="total-savings-not-applicable">
                                      <span class="total-savings-text-label">
                                        {{ 'i18n.orderPage.total' | translate}}
                                      </span>
                                      <span class="total-savings-text">
                                        {{'i18n.orderPage.notApplicable' |
                                        translate}}
                                      </span>
                                    </div>
                                  </ng-template>
                                </div>
                              </div>
                              <div
                                class="vendor-information"
                                *ngIf="shipment.shipmentType === 'vendor'"
                              >
                                <p
                                  *ngIf="!editingVSOrder"
                                  data-cy="tablet-buy-and-save"
                                >
                                  <a (click)="goToDirect($event)"
                                    >{{'i18n.orderPage.buyMoreSave' |
                                    translate}}</a
                                  >
                                  {{'i18n.orderPage.increaseQuantity' |
                                  translate}}
                                </p>
                                <!-- DELIVERY INSTRUCTIONS -->
                                <p
                                  *ngIf="vm?.additionalDeliveryInstructions"
                                  data-cy="delivery-instructions"
                                >
                                  <b
                                    >{{ 'i18n.orderPage.addlInstructions' |
                                    translate }}:</b
                                  >
                                  {{ vm?.additionalDeliveryInstructions }}
                                </p>
                              </div>

                              <div>
                                <ion-button
                                  data-cy="change-date-button"
                                  translate
                                  *ngIf="vm?.hasOrder && shipment?.shipmentType === 'routed'"
                                  class="usf-outline-green-button add-margin"
                                  (click)="presentCalendarPopover($event)"
                                >
                                  {{'i18n.orderPage.changeDate'}}
                                </ion-button>
                              </div>
                            </div>
                          </div>
                        </ion-item>
                        <div
                          class="gray-content-bg"
                          slot="content"
                          tabindex="0"
                          id="ionHeader"
                        >
                          <div
                            *ngIf="shipment?.containsItemBeingFiltered; else noResultsFound"
                          >
                            <ng-container
                              *ngFor="let cartItem of shipment?.cartItems; trackBy: trackByIndex; last as lastItem; let i = index"
                            >
                              <ng-container
                                *ngIf="shipment?.shipmentType === shipmentTypeEnum.vendor ||  !isAlternative(cartItem) || !parentHasQuantity(cartItem)"
                              >
                                <app-usf-product-card-touch
                                  [vm]="shipment?.productCardVms[i]"
                                  (quantityUpdateEmitter)="quantityUpdateHandler($event)"
                                  (ellipsisEmitter)="openProductCardEllipsis($event)"
                                  (productCardClickEmitter)="clickCard($event)"
                                  (infoIconClickEmitter)="openProductStatus($event)"
                                  [hidden]="!cartItem.matchesSearchFilter"
                                ></app-usf-product-card-touch>
                              </ng-container>
                            </ng-container>
                          </div>
                          <ng-template #noResultsFound>
                            <ion-card>
                              <ion-card-content class="no-result-found-text">
                                {{'i18n.orderPage.noProductsWereFound' |
                                translate}}
                              </ion-card-content>
                            </ion-card>
                          </ng-template>
                        </div>
                      </ion-accordion>
                    </ion-accordion-group>
                  </ng-container>
                  <app-deals-banner
                    *ngIf="!vm?.frequentlyBoughtTogetherProducts?.isFeatureEnabled && !editingVSOrder"
                    [bannerStyle]="bannerStyle"
                    [buttonLink]="dealsUrl"
                    [observeAfterLoadedElement]="'#tablet ion-accordion-group'"
                  >
                  </app-deals-banner>
                  <app-merchandising-product-carousel
                    *ngIf="vm?.frequentlyBoughtTogetherProducts?.isFeatureEnabled &&
                     vm?.frequentlyBoughtTogetherProducts?.products?.length > 0 &&
                      !editingVSOrder
                    "
                    observeIntersection
                    class="product-carousel tablet"
                    [platformType]="platformService?.platformType"
                    [title]="vm?.frequentlyBoughtTogetherProducts?.displayText | translate"
                    [products]="vm?.frequentlyBoughtTogetherProducts?.products"
                    (quantityUpdateEmitter)="onFrequentlyBoughtTogetherQuantityUpdate($event.quantityUpdate, $event.index, $event.product)"
                    [linkSource]="frequentlyBoughtTogetherLnkSrc"
                    [observeAfterLoadedElement]="'#tablet ion-accordion-group'"
                    (startObservation)="onFrequentlyBoughtTogetherStartObservation()"
                    (impression)="onFrequentlyBoughtTogetherView()"
                  >
                  </app-merchandising-product-carousel>
                  <ion-row>
                    <ion-col>
                      <p
                        data-cy="tablet-price-info-text"
                        translate
                        *ngIf="vm?.shipments?.length >= 1"
                        class="micro-text"
                      >
                        {{'i18n.orderPage.priceInfoMsg'}}
                      </p>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            </ion-col>
            <ion-col size="4">
              <app-order-info-sidebar
                [platform]="platformService?.platformType"
                [orderHeader]="vm?.orderHeader"
                [orderItemTallies]="vm?.orderItemState?.tallies"
                [isList]="false"
                [isCart]="true"
                [shippingSavings]="vm?.orderTallies?.totalDirectShipmentSavings"
                [isOnMinimumOrderMetFlag]="isOnMinimumOrderMetFlag"
                [isShipmentTypeVendor]="isShipmentTypeVendor"
                [orderMinVm]="orderMinVm"
                [submitButtonText]="vm?.submitButtonText"
                [disableSubmit]="vm?.disableSubmit"
                (submitOrder)="submitOrder($event)"
                (changeDeliveryDate)="presentCalendarPopover($event)"
                (cancelOrder)="deleteOrderModal()"
                (printOrder)="printOrder()"
                (shareOrder)="shareOrder()"
                (downloadOrder)="showDownloadCartModal(true)"
              ></app-order-info-sidebar>
            </ion-col>
          </ion-row>
        </ng-container>
      </ion-grid>
    </div>

    <div
      id="mobile"
      class="gray-content-bg"
      [class.display]="(spinnerSubject | async) === true"
    >
      <ion-grid>
        <ng-template #showNoProductTemplateMobile>
          <ion-row>
            <!-- Mobile No Products -->
            <ion-col id="mobile-no-products" size="12">
              <div class="touch-wrapper">
                <h1 data-cy="mobile-no-product-title">
                  <span translate
                    >{{'i18n.orderPage.noProductTabletMobileL1'}}</span
                  >
                  <br />
                  <span translate
                    >{{'i18n.orderPage.noProductTabletMobileL2'}}</span
                  >
                  <br />
                  <div *ngIf="vm?.hasOrder">
                    <span translate> {{'i18n.orderPage.deliveryDate'}} </span
                    >&nbsp;
                    <span>
                      {{ requestedDeliveryDate | date:'M/d/yyyy':'GMT'}}
                    </span>
                  </div>
                </h1>
                <div class="has-order-container" *ngIf="vm?.hasOrder">
                  <div>
                    <ion-button
                      data-cy="mobile-start-order-button"
                      translate
                      class="usf-fill-green-button"
                      (click)="redirectTo('lists')"
                      id="start-order-btn"
                    >
                      {{'i18n.orderPage.goToMyListBtn'}}
                    </ion-button>

                    <ion-button
                      data-cy="mobile-start-order-button"
                      translate
                      class="usf-outline-green-button"
                      (click)="redirectTo('search')"
                      id="search-order-btn"
                    >
                      {{'i18n.orderPage.addProductsBtn'}}
                    </ion-button>
                  </div>

                  <div>
                    <ion-button
                      data-cy="mobile-cancel-order-button"
                      fill="clear"
                      [hidden]="userAccessRole$ | async"
                      class="usf-outline-orange-button cancel-button"
                      (click)="deleteOrderModal()"
                      translate
                      id="cancel-order-btn"
                    >
                      {{'i18n.orderPage.cancelOrder'}}
                    </ion-button>
                  </div>
                </div>
                <div *ngIf="!vm?.hasOrder">
                  <ion-button
                    data-cy="mobile-start-order-button"
                    translate
                    class="usf-fill-green-button"
                    (click)="redirectTo('lists')"
                  >
                    {{'i18n.orderPage.startOrderBtn'}}
                  </ion-button>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ng-template>
        <ng-container
          *ngIf="vm?.orderItemState?.tallies?.totalItems > 0 else showNoProductTemplateMobile"
        >
          <ng-container>
            <div class="title-container">
              <h2
                *ngIf="!vm?.orderHeader?.tandemOrderNumber"
                class="mobile-title"
              >
                {{'i18n.orderInfoSidebar.reviewOrder' | translate}}
              </h2>
              <h2
                *ngIf="!!vm?.orderHeader?.tandemOrderNumber"
                class="mobile-title"
              >
                {{'i18n.orderPage.editOrder' | translate}}
              </h2>
              <ion-icon
                class="additional-info-ellipsis"
                data-cy="additional-info-ellipsis-icon"
                name="ellipsis-vertical"
                (click)="showDownloadPrintActionSheet(true)"
              ></ion-icon>
            </div>
            <div
              class="copied-from-text"
              *ngIf="!!vm?.orderHeader?.copiedFromTandemOrder"
            >
              <span>{{ 'i18n.orderPage.copiedFromOrder' | translate }}</span>
              <span>{{vm?.orderHeader?.copiedFromTandemOrder}}</span>
            </div>
          </ng-container>
          <!-----------------------START: DYF BANNER-MOBILE---------------------------->
          <ion-row class="dyf-row-wrapper">
            <ng-container
              *ngIf="vm?.dyfProducts?.length > 0 && !editingVSOrder"
            >
              <ion-col
                class="wrapper dyf-wrapper"
                *appShowSplit="[dyfFeatureFlagName]"
              >
                <div class="content">
                  <h2 data-cy="mobile-dyf-title">
                    {{'i18n.orderPage.didYouForget' | translate}}
                  </h2>
                  <p data-cy="mobile-dyf-description">
                    {{vm?.totalDyfProducts + ' '+
                    ('i18n.orderPage.featuredProducts' | translate)}}
                  </p>
                </div>

                <div class="tiles">
                  <ng-container
                    *ngFor="let dyfProductInfo of vm?.dyfProducts; let i = index;"
                  >
                    <div>
                      <ion-card
                        class="tile-container"
                        (click)="navigateToDYFPage(i, dyfProductInfo?.product?.productNumber)"
                      >
                        <img
                          _ngcontent-cnw-c347=""
                          src="{{dyfProductInfo?.imageUrl}}"
                        />
                        <div
                          data-cy="mobile-no-image-icon"
                          class="no-image-container"
                          *ngIf="!dyfProductInfo?.imageUrl"
                          [attr.data-cy]="'mobile-dyf-product-' + dyfProductInfo?.product?.productNumber + '-image'"
                        >
                          <ion-icon name="restaurant"></ion-icon>
                        </div>

                        <div class="swiper-product-descriptions">
                          {{dyfProductInfo?.product?.summary?.productDescTxtl |
                          acronymTitleCase}}
                        </div>
                      </ion-card>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
            </ng-container>
            <!-----------------------END: DYF BANNER-MOBILE---------------------------->

            <!------------------START: INSPIRED PICK BANNER - MOBILE------------------->
            <ng-container
              *ngIf="vm?.inspiredPickProducts?.products?.length  > 0 && !editingVSOrder"
            >
              <ng-container
                *ngIf="!dyfFeatureFlagName||vm?.dyfProducts?.length === 0 "
              >
                <ion-col
                  class="wrapper dyf-wrapper"
                  *appShowSplit="[inspiredPicksFeatureFlagName]"
                >
                  <div class="content">
                    <h2
                      class="inspiredPickDisplayTextMobile"
                      data-cy="inspired-picks-header-mobile-text"
                    >
                      {{vm?.inspiredPickProducts?.displayText.headerTextMobile}}
                    </h2>
                  </div>
                  <div class="tiles">
                    <ng-container
                      *ngFor="let inspiredPickProductsInfo of vm?.inspiredPickProducts?.products; let i = index;"
                    >
                      <div>
                        <ion-card
                          class="tile-container"
                          (click)="navigateToDYFPageFromInspiredPicks(i, inspiredPickProductsInfo?.product?.productNumber)"
                        >
                          <img
                            _ngcontent-cnw-c347=""
                            src="{{inspiredPickProductsInfo?.imageUrl}}"
                            [attr.data-cy]="
                        'inspired-pick-product-' + inspiredPickProductsInfo?.product?.productNumber + '-image'
                        "
                          />
                          <div
                            class="no-image-container"
                            *ngIf="!inspiredPickProductsInfo?.imageUrl"
                            data-cy="inspired-pick-no-image-icon"
                          >
                            <ion-icon name="restaurant"></ion-icon>
                          </div>
                          <div
                            class="swiper-product-descriptions"
                            [attr.data-cy]="
                        'inspired-pick-product-' + inspiredPickProductsInfo?.product?.productNumber + '-description'
                        "
                          >
                            {{inspiredPickProductsInfo?.product?.summary?.productDescTxtl
                            | acronymTitleCase}}
                          </div>
                        </ion-card>
                      </div>
                    </ng-container>
                  </div>
                </ion-col>
              </ng-container>
            </ng-container>
            <!------------------END: INSPIRED PICKS BANNER - MOBILE-->
            <!---------------- START: top sellers ZONE BANNER-MOBILE --------------------------->
            <ng-container
              *ngIf="
                !editingVSOrder &&
                vm?.dyfProducts?.length === 0 &&
                vm?.inspiredPickProducts?.products?.length === 0 &&
                vm?.merchZoneProducts?.length > 0
              "
            >
              <ion-col class="wrapper dyf-wrapper">
                <div class="content">
                  <h2
                    class="merchZoneTitle"
                    data-cy="review-order-merch-zone-title-mobile"
                  >
                    {{ 'i18n.orderPage.topSellers' | translate}}
                  </h2>
                  <p data-cy="review-order-merch-zone-subtitle-mobile">
                    {{ 'i18n.orderPage.dontMissOut' | translate}}
                  </p>
                </div>
                <div class="tiles">
                  <ng-container
                    *ngFor="let newTopSeller of vm?.merchZoneProducts; let i = index;"
                  >
                    <div>
                      <ion-card
                        class="tile-container"
                        (click)="navigateToDYFPageFromMerchZone(i, newTopSeller?.product?.productNumber)"
                      >
                        <img
                          _ngcontent-cnw-c347=""
                          *ngIf="!!newTopSeller?.product?.imageThumbnail"
                          src="{{newTopSeller?.product?.imageThumbnail}}"
                          [attr.data-cy]="
                            'review-order-merch-zone-product-image-mobile-' + i
                          "
                        />
                        <div
                          class="no-image-container"
                          *ngIf="!newTopSeller?.product?.imageThumbnail"
                          [attr.data-cy]="
                            'review-order-merch-zone-product-no-image-icon-mobile-' + i
                          "
                        >
                          <ion-icon name="restaurant"></ion-icon>
                        </div>
                        <div
                          class="swiper-product-descriptions"
                          [attr.data-cy]="
                            'review-order-merch-zone-product-description-mobile-' + i
                          "
                        >
                          {{newTopSeller?.product?.summary?.productDescTxtl |
                          acronymTitleCase}}
                        </div>
                      </ion-card>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
            </ng-container>
            <!---------------- END: top sellers ZONE BANNER-MOBILE ----------------------------->
          </ion-row>
          <!-----------Pronto Banner - Mobile------------>
          <ng-container
            *ngIf="!isShipmentTypeVendor &&
                              (vm?.orderHeader?.orderStatus === orderStatusEnum.IN_PROGRESS ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS) &&
                              checkedForValidRequestedDeliveryDate &&
                              checkedForValidProntoDeliveryDate"
          >
            <div class="pronto-banner" data-cy="pronto-banner-container">
              <ion-row>
                <ion-col size="12">
                  <div class="pronto-banner-content">
                    <h3 data-cy="pronto-banner-title">
                      {{'i18n.orderPage.prontoBannerTitle' | translate}}
                    </h3>
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </ng-container>
          <!-----------Start: Direct Shipping Saving Box - Mobile------------>
          <ng-container *ngIf="isShipmentTypeVendor">
            <ion-row>
              <ion-col>
                <div
                  class="direct-review-box"
                  data-cy="mobile-direct-review-container"
                >
                  <h3 data-cy="mobile-direct-review-title">
                    {{'i18n.orderPage.orderDirectShipments1' | translate}}
                    <span
                      >{{'i18n.orderPage.orderDirectShipments2' |
                      translate}}</span
                    >
                    {{'i18n.orderPage.orderDirectShipments3' | translate}}
                  </h3>
                  <h5
                    data-cy="mobile-direct-review-savings"
                    *ngIf="this.vm?.orderTallies?.totalDirectShipmentSavings > 0"
                  >
                    {{'i18n.orderPage.savingYou1' | translate }}
                    {{this.vm?.orderTallies?.totalDirectShipmentSavings |
                    currency : '$':'symbol':'1.2-2'}}
                    {{'i18n.orderPage.savingYou2' | translate }}
                  </h5>
                  <p
                    *appShowSplit="[directAllowReturnsFlagName]"
                    data-cy="mobile-direct-review-text"
                  >
                    {{'i18n.orderPage.directShipmentFreightMsg' | translate}}
                  </p>
                  <p
                    *appHideSplit="[directAllowReturnsFlagName]"
                    data-cy="mobile-direct-review-text"
                  >
                    {{'i18n.orderPage.directShipmentFreightMsgLine1' |
                    translate}}
                    <strong translate
                      >{{'i18n.orderPage.directShipmentFreightMsgLine2'}}</strong
                    >
                    {{'i18n.orderPage.directShipmentFreightMsgLine3' | translate
                    }}
                  </p>
                  <p data-cy="mobile-direct-review-link">
                    <a
                      class="mobile-direct-orders-link"
                      (click)="scrollToElement('direct-orders-mobile')"
                      >{{'i18n.orderPage.jumpToDirectOrders' | translate}}
                    </a>
                  </p>

                  <ng-container
                    *appShowSplit="[orderDeliveryInstFeatureFlagName]"
                  >
                    <p class="addl-instructions-link">
                      <ng-container
                        *ngIf="vm?.additionalDeliveryInstructions?.length > 0; else showAddLabel"
                      >
                        <b
                          >{{ 'i18n.orderPage.addlInstructions' | translate
                          }}:</b
                        >
                        {{ vm?.additionalDeliveryInstructions }}
                        <a (click)="showAddlInstructionsModal(true)"
                          >{{ 'i18n.common.edit' | translate }}
                        </a>
                      </ng-container>
                      <ng-template #showAddLabel>
                        <b
                          >{{ 'i18n.orderPage.addlInstructions' | translate }}:
                        </b>
                        <a (click)="showAddlInstructionsModal(true)"
                          >{{ 'i18n.common.add' | translate }}
                        </a>
                      </ng-template>
                    </p>
                  </ng-container>
                </div>
              </ion-col>
            </ion-row>
          </ng-container>
          <!-- UNUSUAL QUANTITIES -->
          <ng-container *ngIf="this.vm?.online && vm?.uqeCards?.length > 0">
            <ion-accordion-group [hidden]="false" value="unusual-quantity">
              <ion-accordion
                value="unusual-quantity"
                class="accordion-unusual-qty"
              >
                <ion-item
                  id="no-ripple"
                  class="gray-content-bg accordion-main-row"
                  slot="header"
                >
                  <div class="gray-content-bg accordion-wrapper">
                    <h3>
                      {{ 'i18n.orderPage.unusualQuantities' | translate }}
                      ({{vm?.uqeCards?.length}})
                    </h3>
                    <div class="gray-content-bg accordion-subtitle-info">
                      {{'i18n.orderPage.unusualQuantitiesNote' | translate }}
                    </div>
                  </div>
                </ion-item>
                <div
                  class="gray-content-bg add-padding"
                  slot="content"
                  tabindex="0"
                  id="ionHeader"
                >
                  <div
                    *ngFor="let uqeCard of vm?.uqeCards; trackBy: trackByIndex; last as lastItem; let i = index"
                  >
                    <app-usf-product-card-touch
                      [vm]="uqeCard"
                      (quantityUpdateEmitter)="quantityUpdateHandler($event)"
                      (ellipsisEmitter)="openProductCardEllipsis($event)"
                      (productCardClickEmitter)="clickCard($event)"
                      (infoIconClickEmitter)="openProductStatus($event)"
                      (confirmQuantityEmitter)="confirmUnusualQuantity($event)"
                    ></app-usf-product-card-touch>
                  </div>
                </div>
              </ion-accordion>
            </ion-accordion-group>
          </ng-container>
          <div
            data-cy="order-cart-search-sort-filter-section"
            class="search-sort-filter-section"
          >
            <div class="search-container">
              <ion-searchbar
                id="list-search-bar--0"
                data-cy="list-detail-searchbar"
                class="search"
                mode="md"
                placeholder="{{ 'i18n.orderPage.searchWithinYourCart' | translate}}"
                [(ngModel)]="searchKey"
                (ionInput)="orderItemSearch()"
              >
              </ion-searchbar>
            </div>
          </div>
          <ng-container
            *ngFor="let shipment of vm?.shipments; trackBy: trackByIndex; let shipmentIndex = index"
          >
            <ion-accordion-group value="shipment">
              <ion-accordion value="shipment">
                <ion-item
                  id="no-ripple"
                  class="gray-content-bg accordion-main-row"
                  slot="header"
                >
                  <div class="shipment-info-row">
                    <div class="shipping-title-section">
                      <div>
                        <h3
                          *ngIf="shipment.shipmentType === 'routed'"
                          translate
                          data-cy="mobile-routed-order-title"
                        >
                          <ng-container
                            *ngIf="isProntoDay(
                              !dateChange &&
                                (vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_CREDIT_HOLD ||
                                  vm?.orderHeader?.orderStatus === orderStatusEnum.SUBMITTED_WITH_EXCEPTIONS) ?
                              vm?.orderHeader?.confirmedDeliveryDate?.toString() :
                              shipment?.deliveryDate?.toString()); else originalHeader"
                          >
                            {{ 'i18n.orderPage.prontoOrderDeliveryTouch' |
                            translate }}
                          </ng-container>
                          <ng-template #originalHeader>
                            {{ 'i18n.orderPage.routedOrderDeliveryTouch' }}
                          </ng-template>
                          <span
                            *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                          >
                            {{vm?.usfOrderDeliveryDate | date:'M/d':'GMT'}}
                          </span>
                          <span
                            *ngIf="!nextDeliveryInfo?.creditIndicator"
                            translate
                          >
                            {{ 'i18n.orderPage.notApplicable' }}
                          </span>
                        </h3>

                        <h3
                          *ngIf="shipment.shipmentType === 'vendor'"
                          translate
                          data-cy="mobile-vendor-order-title"
                          id="direct-orders-mobile"
                        >
                          {{'i18n.orderPage.vendorOrderDeliveryTouch'}}
                          <span
                            *ngIf="nextDeliveryInfo && nextDeliveryInfo.creditIndicator"
                            >{{shipment.deliveryDate | date:'M/d':'GMT'}}
                          </span>
                          <span
                            *ngIf="!nextDeliveryInfo?.creditIndicator"
                            translate
                          >
                            {{ 'i18n.orderPage.notApplicable' }}
                          </span>
                        </h3>

                        <ion-button
                          data-cy="mobile-change-order-button"
                          translate
                          *ngIf="vm?.hasOrder && shipment?.shipmentType === 'routed'"
                          class="usf-green-link-button calendar-button"
                          (click)="presentCalendarPopover($event)"
                        >
                          {{'i18n.orderPage.change'}}

                          <ion-icon
                            class="calendar-icon"
                            name="calendar-outline"
                          ></ion-icon>
                        </ion-button>
                      </div>

                      <div
                        class="accordion-subtitle-info"
                        [ngClass]="shipment.shipmentType === 'vendor' ? 'product-info_vendor' : ''"
                      >
                        <div data-cy="mobile-product-info">
                          {{'i18n.orderPage.total' | translate}}
                          {{shipment.shipmentTallies?.totalPrice | currency}}
                          ({{shipment?.shipmentTallies?.totalCases}}
                          {{'i18n.orderPage.cs' |
                          translate}}/{{shipment?.shipmentTallies?.totalEaches}}
                          {{'i18n.orderPage.ea' | translate}})
                        </div>
                        <div
                          data-cy="shipping-savings-text"
                          class="total-shipping-savings-text"
                          *ngIf="shipment.shipmentType === 'vendor'  && shipment?.shipmentTallies?.totalDirectShipmentSavings"
                        >
                          <span class="mini-border">|</span>
                          {{'i18n.orderPage.shippingSavings' | translate}}
                          {{shipment?.shipmentTallies?.totalDirectShipmentSavings
                          || 0 | currency : '$':'symbol':'1.2-2'}}
                        </div>
                      </div>
                      <div
                        class="vendor-information"
                        *ngIf="shipment.shipmentType === 'vendor'"
                      >
                        <p
                          *ngIf="!editingVSOrder"
                          data-cy="mobile-buy-and-save"
                        >
                          <a (click)="goToDirect($event)"
                            >{{ "i18n.orderPage.buyMoreSave" | translate }}</a
                          >
                          {{ "i18n.orderPage.increaseQuantity" | translate }}
                        </p>
                        <!-- DELIVERY INSTRUCTIONS -->
                        <p
                          *ngIf="vm?.additionalDeliveryInstructions"
                          data-cy="delivery-instructions"
                        >
                          <b
                            >{{ 'i18n.orderPage.addlInstructions' | translate
                            }}:</b
                          >
                          {{ vm?.additionalDeliveryInstructions }}
                        </p>
                      </div>
                    </div>
                  </div>
                </ion-item>
                <div
                  class="gray-content-bg"
                  slot="content"
                  tabindex="0"
                  id="ionHeader"
                >
                  <div
                    *ngIf="shipment?.containsItemBeingFiltered; else noResultsFound"
                  >
                    <ng-container
                      *ngFor="let cartItem of shipment?.cartItems; trackBy: trackByIndex; last as lastItem; let i = index"
                    >
                      <ng-container
                        *ngIf="shipment?.shipmentType === shipmentTypeEnum.vendor ||  !isAlternative(cartItem) || !parentHasQuantity(cartItem)"
                      >
                        <app-usf-product-card-touch
                          [vm]="shipment?.productCardVms[i]"
                          (quantityUpdateEmitter)="quantityUpdateHandler($event)"
                          (ellipsisEmitter)="openProductCardEllipsis($event)"
                          (productCardClickEmitter)="clickCard($event)"
                          (infoIconClickEmitter)="openProductStatus($event)"
                          [hidden]="!cartItem.matchesSearchFilter"
                        ></app-usf-product-card-touch>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <ng-template #noResultsFound>
                  <ion-card>
                    <ion-card-content class="no-result-found-text">
                      {{'i18n.orderPage.noProductsWereFound' | translate}}
                    </ion-card-content>
                  </ion-card>
                </ng-template>
              </ion-accordion>
            </ion-accordion-group>
          </ng-container>
          <app-deals-banner
            *ngIf="!vm?.frequentlyBoughtTogetherProducts?.isFeatureEnabled && !editingVSOrder"
            [bannerStyle]="bannerStyle"
            [buttonLink]="dealsUrl"
            [observeAfterLoadedElement]="'#mobile ion-accordion-group'"
          >
          </app-deals-banner>
          <app-merchandising-product-carousel
            *ngIf="vm?.frequentlyBoughtTogetherProducts?.isFeatureEnabled &&
              vm?.frequentlyBoughtTogetherProducts?.products?.length > 0 &&
              !editingVSOrder
            "
            observeIntersection
            class="product-carousel"
            [platformType]="platformService?.platformType"
            [title]="vm?.frequentlyBoughtTogetherProducts?.displayText | translate"
            [products]="vm?.frequentlyBoughtTogetherProducts?.products"
            (quantityUpdateEmitter)="onFrequentlyBoughtTogetherQuantityUpdate($event.quantityUpdate, $event.index, $event.product)"
            [linkSource]="frequentlyBoughtTogetherLnkSrc"
            [observeAfterLoadedElement]="'#mobile ion-accordion-group'"
            (startObservation)="onFrequentlyBoughtTogetherStartObservation()"
            (impression)="onFrequentlyBoughtTogetherView()"
          >
          </app-merchandising-product-carousel>

          <ion-row>
            <ion-col>
              <p
                data-cy="mobile-price-info-text"
                translate
                *ngIf="vm?.shipments?.length >= 1"
                class="micro-text"
              >
                {{'i18n.orderPage.priceInfoMsg'}}
              </p>
            </ion-col>
          </ion-row>
        </ng-container>
      </ion-grid>
    </div>
  </div>
</ion-content>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="downloadCartModalIsOpen$ | async"
  (ionModalDidDismiss)="showDownloadCartModal(false)"
>
  <ng-template>
    <app-simple-download-orders-modal
      class="ion-page"
      [orders]="cartToOrderArray()"
      [fileTypes]="downloadCartFileTypes"
      [fileName]="formatDownloadFileName()"
      [platform]="platformService?.platformType"
      (dismissEvent)="showDownloadCartModal(false)"
      (downloadOrdersEmitter)="handleDownloadCart($event)"
    >
    </app-simple-download-orders-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'addl-instructions-modal'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="addlInstructionsModalIsOpen$ | async"
  (ionModalDidDismiss)="handleAddlInstructionsModalDismiss($event)"
>
  <ng-template>
    <app-additional-instructions-modal
      class="ion-page"
      [instructions]="vm?.additionalDeliveryInstructions"
      (instructionsAdded)="handleInstructionsAdded($event)"
    >
    </app-additional-instructions-modal>
  </ng-template>
</ion-modal>

<ion-action-sheet
  class="action-sheet-touch"
  mode="ios"
  [isOpen]="downloadPrintActionSheetIsOpen$ | async"
  (didDismiss)="showDownloadPrintActionSheet(false)"
  [buttons]="downloadPrintButtons"
></ion-action-sheet>

<!-- Order Footer -->
<ng-container *ngIf="vm?.orderItemState?.tallies?.totalItems > 0">
  <ion-footer class="hide-tablet hide-desktop">
    <ion-toolbar class="toolbar-footer">
      <div class="toolbar-wrapper">
        <div>
          <p class="toolbar-lg-txt" data-cy="mobile-order-total-text">
            <span translate>{{'i18n.orderPage.total'}} </span>
            <span
              *ngIf="!vm?.orderHeader?.priceChangeFlag && selectedCustomer?.ogPrintPriceInd !== 'N'"
              >{{ (totalPrice$ | async) | currency }}</span
            >
            <span
              *ngIf="vm?.orderHeader?.priceChangeFlag && selectedCustomer?.ogPrintPriceInd !== 'N'"
              >{{ vm?.orderTallies?.totalPrice | currency }}</span
            >
            <span *ngIf="selectedCustomer?.ogPrintPriceInd === 'N'" translate
              >{{ "i18n.orderPage.notApplicable" | translate }}</span
            >
          </p>

          <p
            class="toolbar-sm-text no-margin"
            data-cy="mobile-product-items-text"
          >
            {{'i18n.orderPage.product' | translate}}{{
            vm?.orderTallies?.totalItems === 1 ? '' : 's' }}:
            {{vm?.orderItemState?.ids?.length}}
            ({{vm?.orderTallies?.totalCases}} {{'i18n.orderPage.cs' |
            translate}} / {{vm?.orderTallies?.totalEaches}}
            {{'i18n.orderPage.ea' | translate}})
          </p>
          <p data-cy="mobile-order-weight-text" class="toolbar-sm-text">
            {{'i18n.orderPage.orderWeight' | translate}} {{ !!vm?.orderHeader ?
            (orderWeight$ | async | number: '1.1-2') : 0.0 }}
            {{'i18n.orderPage.lb' | translate}}
          </p>
        </div>
        <div>
          <ion-button
            data-cy="mobile-review-submit-button"
            id="review-and-submit-btn"
            (click)="openSubmitModalMobile($event)"
            [disabled]="isSubmitting || (userAccessRole$ | async) || vm?.disableSubmit"
            [class]="vm?.restrictToOG || isSubmitting || (userAccessRole$ | async) ||  vm?.disableSubmit ?  'usf-fill-disabled-button' : 'usf-fill-green-button'"
            translate
            >{{'i18n.orderPage.goToSubmit'}}</ion-button
          >
          <a
            *ngIf="vm?.orderHeader?.orderStatus === 'SUBMITTED' ||
              vm?.orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
              vm?.orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS'"
            data-cy="mobile-discard-Edits-button"
            class="usf-fill-green-button discard-link"
            id="discard-edits-btn"
            translate
            (click)="openDiscardOrderModalMobile($event)"
          >
            {{'i18n.orderInfoSidebar.discardEdits'}}
          </a>
        </div>
      </div>
    </ion-toolbar>
  </ion-footer>
</ng-container>

<!-- Floating Tooltip for Cart -->
<div class="help-icon">
  <img
    data-cy="order-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>

<div data-cy="review-order-top-button-section" class="scroll-to-top-button">
  <ion-button
    data-cy="review-order-top-button"
    class="usf-fill-green-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}&nbsp;
    <ion-icon
      data-cy="review-order-top-button-icon"
      name="chevron-up"
    ></ion-icon>
  </ion-button>
</div>
